module.exports = __webpack_public_path__ + "cb812a85e708ef3387548d60b227473d.pdf";